import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nextToPromise } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { NuevoManifiestoRADForm } from "./form";
const NuevoManifiestoRADFormRx = NuevoManifiestoRADForm;
type Entity = models.NuevoManifiestoRADModel;
const resource = resources.ManifiestoRAD;
const session = resources.User.SessionRx;

interface State {
    value: Entity;
}
class NuevoManifiestoRADEditComp extends React.PureComponent<{}, State> {
    constructor(props: {}) {
        super(props);
        this.state = {
            value: {
                FoliosGuias: [],
                IdDireccionClienteOrigen: undefined as any,
                IdSucursal: undefined as any,
                IdCamion: undefined as any,
                IdChofer: undefined as any
            } as Entity
        };
    }

    value = (state: State) => state.value;

    onChange = (value: Entity) => {

        console.log(value);
        debugger;
        new Promise<void>(resolve => this.setState({ value: value }, resolve));
    }
    onGuardar = async () => {
        debugger;
        const value = this.value(this.state);
        await resource.AgregarManifiesto(value);
        await kea.message("Manifiesto de RAD agregado");
        history.go("../");
    }

    render() {
        const value = this.value(this.state);
        return <NuevoManifiestoRADFormRx
            value={value}
            onChange={this.onChange}
            onGuardar={this.onGuardar}
            session={session}
        />;
    }
}

export const NuevoManifiestoRADEdit = withRouter(NuevoManifiestoRADEditComp);



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/manifiestorad/nuevo/edit.tsx